// src/components/LinksManagerAddForm.js
import React from "react";
import { Crown } from "lucide-react";
import styles from "./LinksManager.module.css";

// Set link limits by tier
const FREE_LINK_LIMIT = 5;
const PRO_LINK_LIMIT = 25;

// Format URL function
const formatUrl = (url) => {
  // Trim any whitespace
  let formattedUrl = url.trim();
  
  // If URL is empty, return as is
  if (!formattedUrl) return formattedUrl;

  // Check if the URL already has a protocol (http://, https://, ftp://, etc.)
  const hasProtocol = /^[a-zA-Z]+:\/\//.test(formattedUrl);
  
  // If no protocol is present, add https://
  if (!hasProtocol) {
    formattedUrl = `https://${formattedUrl}`;
  }
  
  return formattedUrl;
};

const LinksManagerAddForm = ({
  newLink,
  setNewLink,
  addLink,
  updateLink,
  editingId,
  links,
  isProUser,
  formInputRef,
}) => {
  // Calculate link limits based on user tier
  const linkLimit = isProUser ? PRO_LINK_LIMIT : FREE_LINK_LIMIT;
  const remainingLinks = linkLimit - links.length;

  // Handle URL change with formatting
  const handleUrlChange = (e) => {
    setNewLink({ ...newLink, url: e.target.value });
  };

  // Handle submission with URL formatting
  const handleSubmit = () => {
    // Format URL before submitting
    const formattedUrl = formatUrl(newLink.url);
    setNewLink({ ...newLink, url: formattedUrl });
    
    if (editingId) {
      updateLink();
    } else {
      addLink();
    }
  };

  return (
    <div className={styles.addLinkForm}>
      <div className={styles.formInputs}>
        <input
          ref={formInputRef}
          type="text"
          placeholder="Link Title"
          value={newLink.title}
          onChange={(e) =>
            setNewLink({ ...newLink, title: e.target.value.slice(0, 40) })
          }
          maxLength={40}
          className={styles.input}
          disabled={links.length >= linkLimit && !editingId}
        />
        <input
          type="url"
          placeholder="URL (website address)"
          value={newLink.url}
          onChange={handleUrlChange}
          className={styles.input}
          disabled={links.length >= linkLimit && !editingId}
        />
      </div>
      <button
        onClick={handleSubmit}
        className={styles.addButton}
        disabled={
          !newLink.title ||
          !newLink.url ||
          (links.length >= linkLimit && !editingId)
        }
      >
        {editingId ? "Update" : "Add"}
      </button>
      <span style={{ color: "#333333", marginLeft: "5px" }}>
        {links.length < linkLimit
          ? `${links.length} links used (${remainingLinks} remaining)`
          : `Maximum ${linkLimit} links reached`}
      </span>
      
      {!isProUser && (
        <div className={styles.upgradeTip}>
          <Crown size={14} className={styles.crownIcon} />
          <span className={styles.upgradetopro}>
            Upgrade to Pro for {PRO_LINK_LIMIT} links
          </span>
        </div>
      )}
    </div>
  );
};

export default LinksManagerAddForm;